import React from 'react';

const IconRecovery = props => (<svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
  <path d="M21.5 11c0 4.97-4.029 9-9 9c-2.49 0-4.73-1.01-6.36-2.641l1.42-1.42C8.82 17.21 10.57 18 12.5 18 c3.87 0 7-3.13 7-7s-3.13-7-7-7s-7 3.13-7 7h3l-4.04 4.03l-0.07-0.14L0.5 11h3c0-4.97 4.03-9 9-9C17.471 2 21.5 6.03 21.5 11z M11.5 7v5l4.279 2.54l0.721-1.21L13 11.25V7H11.5z" />
</svg>);

export default IconRecovery;
